import type { JSX } from '@builder.io/qwik';
import { component$, useSignal } from '@builder.io/qwik';
import ShareIcon from '~/icons/share';
import ArticleShare from '~/components/Layout/Body/Article/ArticleShare/ArticleShare';
import { cva } from 'class-variance-authority';

const cssContainer = cva('md:hidden flex items-center relative', {
  variants: {
    orientation: {
      vertical: '',
      horizontal: 'hidden',
      dropdown: '',
    },
  },
});

const cssClasses = cva('share-menu', {
  variants: {
    active: {
      true: '',
      false: 'hidden',
    },
  },
});

interface ArticleMobileShareButtonProps {
  orientation?: 'vertical' | 'horizontal' | 'dropdown';
}

export default component$<ArticleMobileShareButtonProps>(
  ({ orientation = 'dropdown' }): JSX.Element => {
    const active = useSignal(false);

    return (
      <div class={cssContainer({ orientation })}>
        <button
          class='w-9 h-9'
          aria-label='share'
          onClick$={() => {
            active.value = !active.value;
          }}
        >
          <ShareIcon cssClasses='fill-primary max-w-6 max-h-6' />
        </button>
        <div
          class={cssClasses({
            active: active.value,
          })}
        >
          <ArticleShare orientation='dropdown' device='mobile' />
        </div>
      </div>
    );
  }
);
